<div class="cookies-details">
  <h1>Cookies Policy</h1>
  <p>
    We use cookies on our website for a number of purposes. <br />
    They help us provide you with a good experience when you browse our website and allow us to improve it.<br />
    A cookie is a small file of letters and numbers that we store on your browser or your device when you visit our
    website. We use the following cookies:
  </p>
  <h3>Necessary Cookies</h3>
  <p>
    These cookies are essential and required for the correct operation of our website. <br />
    They enable you to securely browse our website and allow us to route your requests, maintain your session, and recognize your preferences
    so that we can provide you with the services you asked for.<br />
    We automatically collect log data when you access and use our website. We use this information to administer and
    improve our website and/or services, and to support you.
  </p>
  <section class="cookies-details__list-section">
    <table>
      <thead>
        <th>Cookie Name</th>
        <th>Provider</th>
        <th>Purpose</th>
        <th>Expiry</th>
        <th>Category</th>
      </thead>
      <tbody>
        <tr>
          <td>lang</td>
          <td>SABIS<sup>®</sup></td>
          <td>This cookie is used to store your language preference.</td>
          <td>Session</td>
          <td>Necessary</td>
        </tr>
        <tr>
          <td>.AspNetCore.AzureADCookie</td>
          <td>ASP.NET Core Identity</td>
          <td>This cookie is set by the Identity Server application that makes use of Asp.Net Identity to manage the user session in Azure AD.</td>
          <td>Session</td>
          <td>Necessary</td>
        </tr>
        <tr>
          <td>.AspNetCore.AzureADCookieC1</td>
          <td>ASP.NET Core Identity</td>
          <td>This cookie is set by the Identity Server application that makes use of Asp.Net Identity to manage the user session in Azure AD.</td>
          <td>Session</td>
          <td>Necessary</td>
        </tr>
        <tr>
          <td>.AspNetCore.AzureADCookieC2</td>
          <td>ASP.NET Core Identity</td>
          <td>This cookie is set by the Identity Server application that makes use of Asp.Net Identity to manage the user session in Azure AD.</td>
          <td>Session</td>
          <td>Necessary</td>
        </tr>
        <tr>
          <td>.AspNetCore.Identity.Application</td>
          <td>ASP.NET Core Identity</td>
          <td>This cookie is used when accessing our website which requires username and password authentication. This cookie determines that a user is logged in. When the user logs out of the application, this cookie is removed from the browser.</td>
          <td>Session</td>
          <td>Necessary</td>
        </tr>
        <tr>
          <td>idsrv.session</td>
          <td>Identity Server framework</td>
          <td>This cookie is used to check the session of the user at sign-out time. It is kept in sync with the authentication cookie, and is removed when the user signs out.</td>
          <td>Session</td>
          <td>Necessary</td>
        </tr>
        <tr>
          <td>TS016f0357</td>
          <td>SABIS<sup>®</sup></td>
          <td>This cookie is associated with the BIG-IP product suite from the F5 company, to ensure that users' requests are consistently routed to the correct server where the website is hosted.</td>
          <td>Session</td>
          <td>Necessary</td>
        </tr>
        <tr>
          <td>Cookie_Banner_Preferences</td>
          <td>SABIS<sup>®</sup></td>
          <td>This cookie stores the user's cookie consent for the current website.</td>
          <td>2 months</td>
          <td>Necessary</td>
        </tr>
      </tbody>
    </table>
  </section>
</div>
